if (!customElements.get('bundle-product-form')) {
  customElements.define('bundle-product-form', class BundleProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.bundleVariantRadios = Array.from(this.querySelectorAll('bundle-variant-radios'))
      this.handleOnVariantsChange()
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    handleOnVariantsChange() {
      this.bundleVariantRadios.forEach((bundle) => {
        const emitUpdate = () => {
          const variant = bundle.getSelectedVariant ? bundle.getSelectedVariant() : null
          this.updateBundleTitle(bundle, variant ? [variant] : [])
          this.updateButtonSubmit()
        }

        bundle.addEventListener('variant-change', emitUpdate)
        bundle.addEventListener('style-change', emitUpdate)

        // initialize title state
        emitUpdate()
      })

      this.updateButtonSubmit()
    }

    updateButtonSubmit() {
      const allBundlesReady = this.bundleVariantRadios.every((bundle) => {
        if (!bundle.getSelectedVariant) return false
        const variant = bundle.getSelectedVariant()
        return variant && variant.available
      })

      this.submitButton.disabled = !allBundlesReady
    }

    updateBundleTitle(bundle, variants) {
      const summary = bundle.querySelector('.js-bundle-variants-title')

      if (!summary) return

      if (!summary.dataset.defaultTitle) {
        summary.dataset.defaultTitle = summary.textContent.trim()
      }

      const activePanel =
        bundle.querySelector('.bundle-variants-content__inner[style*="display: block"]') ||
        bundle.querySelector('.bundle-variants-content__inner.is-active') ||
        bundle.querySelector('.bundle-variants-content__inner')
      const activeStyle =
        (variants && variants[0] && variants[0].styleLabel) ||
        (activePanel && (activePanel.dataset.styleLabel || '').trim()) ||
        (() => {
          const activeTab = bundle.querySelector('.bundle-variants-tab.active') || bundle.querySelector('.bundle-variants-tab.is-active')
          return activeTab ? (activeTab.dataset.styleLabel || activeTab.textContent || '').trim() : ''
        })()

      if (Array.isArray(variants) && variants.length > 0) {
        const variant = variants[0]
        const variantTitle = variant && variant.title ? variant.title : ''
        if (variantTitle) {
          const formattedStyle = activeStyle || ''
          const formattedTitle = formattedStyle ? `${formattedStyle} - ${variantTitle}` : variantTitle
          summary.innerHTML = formattedTitle
          return
        }
        if (activeStyle) {
          summary.innerHTML = activeStyle
          return
        }
      }

      summary.innerHTML = summary.dataset.defaultTitle || summary.innerHTML
    }

    getBundleQuantityIndexes(bundleEl) {
      if (!bundleEl) return []
      if (typeof bundleEl.getQuantityIndexes === 'function') {
        return bundleEl.getQuantityIndexes()
      }
      return Array.from(bundleEl.querySelectorAll('.bundle-variants-content__inner'))
        .map((instance) => instance.dataset.quantityIndex)
        .filter(Boolean)
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.bundleVariantRadios.length <= 0) return
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      // Collect all variants from all quantity instances
      const items = this.bundleVariantRadios.reduce((acc, bundle) => {
        if (!bundle.getSelectedVariant) return acc
        const variant = bundle.getSelectedVariant()
        if (variant && variant.id) {
          acc.push({
            id: variant.id,
            quantity: 1
          })
        }
        return acc
      }, [])

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('json');
      let params = ''

      if (this.cart) {
        this.cart.setActiveElement(document.activeElement);
        params = this.cart.getSectionsToRender().map((section) => section.id)
      }
      config.body = JSON.stringify({
        items
      });

      fetch(`${routes.cart_add_url}.js${params ? `?sections=${this.cart.getSectionsToRender().map((section) => section.id)}&sections_url=${window.location.pathname}` : ''}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
class BundleVariantRadios extends HTMLElement {
  constructor() {
    super();
    this.listOptions = this.dataset.options ? JSON.parse(this.dataset.options) : []
    this.selectedVariants = {}
    this.variantDataByQuantity = this.loadVariantData()
    this.variantDataFallback = null
    this.quantityIndexOrder = this.collectQuantityIndexes()
    this.activeQuantityIndex = this.quantityIndexOrder[0] || null
    this.addEventListener('change', this.onVariantChange);
    this.handleOpenSelectsBundle()
    this.handleOpenTabsBundle()
  }

  onVariantChange(event) {
    const quantityIndex = event.target.closest('.bundle-variants-content__inner')?.dataset.quantityIndex
    const indexKey = quantityIndex ?? this.activeQuantityIndex ?? this.quantityIndexOrder[0] ?? null

    if (quantityIndex && this.activeQuantityIndex && quantityIndex !== this.activeQuantityIndex) {
      return
    }

    if (indexKey) {
      this.updateOptions(indexKey);
      this.updateMasterId(indexKey);
    } else {
      const fallbackIndex = this.activeQuantityIndex || this.quantityIndexOrder[0] || null
      this.updateOptions(fallbackIndex);
      this.updateMasterId(fallbackIndex);
    }
    this.removeErrorMessage();
    this.updateAvailableSelects()

    // Update all variant inputs for all quantity instances
    this.updateAllVariantInputs();
  }

  handleOpenSelectsBundle() {
    const summary = this.querySelector('.js-bundle-variants-summary')

    if (summary) {
      summary.addEventListener('click', (e) => {
        e.preventDefault()

        this.classList.toggle('is-open')
      })
    }
  }

  handleOpenTabsBundle() {
    const tabs = this.querySelectorAll('.bundle-variants-tab')
    const contents = this.querySelectorAll('.bundle-variants-content__inner')
    if (tabs.length > 0) {
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', (e) => {
          e.preventDefault()
          const quantityIndex = tab.dataset.quantityIndex || this.quantityIndexOrder[index] || null
          if (quantityIndex) {
            this.activeQuantityIndex = quantityIndex
          }
          tabs.forEach(tab => tab.classList.remove('active'))
          contents.forEach(content => {
            const shouldShow = tab.dataset.quantityIndex
              ? content.dataset.quantityIndex === tab.dataset.quantityIndex
              : index === Array.from(contents).indexOf(content)
            content.style.display = shouldShow ? 'block' : 'none'
            content.classList.toggle('is-active', shouldShow)
          })
          tab.classList.add('active')

          this.updateOptions(quantityIndex || null)
          this.updateMasterId(quantityIndex || null)
          this.updateAvailableSelects()
          this.updateAllVariantInputs()

          this.dispatchEvent(new CustomEvent('style-change', {
            detail: {
              quantityIndex: quantityIndex ? parseInt(quantityIndex, 10) : null,
              styleLabel: this.getStyleLabel(quantityIndex || null)
            }
          }))
        })
      })
    }
  }

  updateOptions(quantityIndex = null) {
    // If quantityIndex is provided, only get options from that specific quantity instance
    const targetIndex = quantityIndex !== null ? quantityIndex : this.activeQuantityIndex
    const selector = targetIndex !== null
      ? `.bundle-variants-content__inner[data-quantity-index="${targetIndex}"] .product-form__value`
      : '.bundle-variants-content__inner .product-form__value'
    const fieldsets = Array.from(this.querySelectorAll(selector));
    this.options = fieldsets.map((fieldset) => {
      const optionSelectedEl = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)
      if (optionSelectedEl) {
        return optionSelectedEl.value
      }
      return null
    });
  }

  updateAvailableSelects() {
    // Update available selects for each quantity instance separately
    const quantityInstances = Array.from(this.querySelectorAll('.bundle-variants-content__inner'))
    
    quantityInstances.forEach(instance => {
      const quantityIndex = instance.dataset.quantityIndex
      const variantPayload = this.getVariantDataFor(quantityIndex)
      if (!variantPayload || !Array.isArray(variantPayload.variants)) {
        return
      }
      const fieldsets = Array.from(instance.querySelectorAll('.product-form__value'))
      if (!fieldsets.length) {
        return
      }
      const selected = fieldsets.reduce((acc, cur) => {
        const optionSelectedEl = Array.from(cur.querySelectorAll('input')).find((radio) => radio.checked);

        if (optionSelectedEl) {
          const optionSelected = { [optionSelectedEl.dataset.optionName]: optionSelectedEl.value }
          return { ...acc, ...optionSelected }
        } else return acc
      }, {})
      const optionNames = fieldsets.map(fieldset => fieldset.dataset.optionName)
      const availableValues = this.getAvailableValues(optionNames, variantPayload.variants)
      const selectableValues = this.getSelectableValues(optionNames, availableValues, selected, variantPayload.variants)

      fieldsets.forEach(fieldset => {
        const optionName = fieldset.dataset.optionName
        const inputs = Array.from(fieldset.querySelectorAll('input'))

        inputs.forEach(input => {
          if (!selectableValues[optionName] || !selectableValues[optionName].includes(input.value)) {
            input.classList.add('disabled')
          } else {
            input.classList.remove('disabled')
          }
        })
      })
    })
  }

  getAvailableValues(optionNames, variants) {
    if (!Array.isArray(optionNames) || !Array.isArray(variants)) {
      return {}
    }
    const values = {}
    optionNames.forEach((optionName, optionIndex) => {
      values[optionName] = []
      variants.forEach((variant) => {
        const value = variant.options?.[optionIndex]
        if (value && !values[optionName].includes(value)) {
          values[optionName].push(value)
        }
      })
    })
    return values
  }

  getSelectableValues(optionNames, availableValues, selected, variants) {
    if (!Array.isArray(optionNames)) {
      return availableValues
    }
    const selectable = { ...availableValues }
    optionNames.forEach((optionName, optionIndex) => {
      const filters = Object.entries(selected).filter(([name]) => name !== optionName)
      const filteredValues = variants
        .filter((variant) => {
          if (!variant.available) return false
          return filters.every(([name, value]) => {
            const filterIndex = optionNames.indexOf(name)
            return filterIndex === -1 || variant.options?.[filterIndex] === value
          })
        })
        .map((variant) => variant.options?.[optionIndex])
        .filter((value, idx, arr) => value && arr.indexOf(value) === idx)

      if (filteredValues.length) {
        selectable[optionName] = filteredValues
      } else if (!filters.length) {
        selectable[optionName] = variants
          .filter((variant) => variant.available)
          .map((variant) => variant.options?.[optionIndex])
          .filter((value, idx, arr) => value && arr.indexOf(value) === idx)
      }
    })
    return selectable
  }

  updateMasterId(quantityIndex = null) {
    const indexToUse = quantityIndex !== null ? String(quantityIndex) : (this.activeQuantityIndex || this.quantityIndexOrder[0] || null)
    const key = indexToUse !== null ? String(indexToUse) : null
    if (!key) {
      return
    }

    if (!this.options || this.options.some((value) => value === null)) {
      this.selectedVariants[key] = null
      this.dispatchEvent(new CustomEvent('variant-change', {
        detail: {
          quantityIndex: parseInt(key, 10),
          available: false,
          styleLabel: this.getStyleLabel(key)
        }
      }))
      if (key === String(this.activeQuantityIndex || this.quantityIndexOrder[0])) {
        this.currentVariant = null
      }
      return
    }

    const variantPayload = this.getVariantDataFor(key)
    const optionNames = variantPayload?.options || this.listOptions || []
    const variants = variantPayload?.variants || []
    const variant = variants.find((candidate) => {
      return optionNames.every((_, optionIndex) => this.options[optionIndex] === candidate.options?.[optionIndex])
    })

    if (variant) {
      const variantDetail = {
        ...variant,
        quantityIndex: parseInt(key, 10),
        styleLabel: this.getStyleLabel(key)
      }
      this.selectedVariants[key] = variantDetail
      if (key === String(this.activeQuantityIndex || this.quantityIndexOrder[0])) {
        this.currentVariant = variantDetail
      }
      this.dispatchEvent(new CustomEvent('variant-change', {
        detail: variantDetail
      }))
    } else {
      this.selectedVariants[key] = null
      this.dispatchEvent(new CustomEvent('variant-change', {
        detail: {
          quantityIndex: parseInt(key, 10),
          available: false,
          styleLabel: this.getStyleLabel(key)
        }
      }))
      if (key === String(this.activeQuantityIndex || this.quantityIndexOrder[0])) {
        this.currentVariant = null
      }
    }
  }

  getStyleLabel(quantityIndex = null) {
    const key = quantityIndex !== null ? String(quantityIndex) : (this.activeQuantityIndex || this.quantityIndexOrder[0] || null)
    if (!key) {
      return ''
    }
    const tab = this.querySelector(`.bundle-variants-tab[data-quantity-index="${key}"]`)
    if (tab) {
      return (tab.dataset.styleLabel || tab.textContent || '').trim()
    }
    const panel = this.querySelector(`.bundle-variants-content__inner[data-quantity-index="${key}"]`)
    if (panel) {
      return (panel.dataset.styleLabel || '').trim()
    }
    return ''
  }

  getAllSelectedVariants() {
    const variant = this.getSelectedVariant()
    return variant ? [variant] : []
  }

  getSelectedVariant() {
    const key = this.activeQuantityIndex || this.quantityIndexOrder[0] || null
    if (!key) {
      return null
    }
    return this.selectedVariants[String(key)] || null
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (this.currentVariant && input) {
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  updateAllVariantInputs() {
    // Update variant inputs for all quantity instances
    const variant = this.getSelectedVariant()
    if (variant) {
      // Use the first variant for the main product form (if it exists)
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (input) {
          input.value = variant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  loadVariantData() {
    const data = {}
    const variantScripts = this.querySelectorAll('script[data-variants]')
    variantScripts.forEach((script) => {
      const quantityIndex = script.dataset.quantityIndex
      if (!quantityIndex) return
      try {
        const parsed = JSON.parse(script.textContent.trim())
        if (parsed) {
          if (Array.isArray(parsed)) {
            data[quantityIndex] = { options: this.listOptions, variants: parsed }
          } else {
            data[quantityIndex] = parsed
          }
        }
      } catch (error) {
        console.error('bundle-variant-radios: unable to parse variant data', error)
      }
    })

    if (!Object.keys(data).length) {
      const fallbackScript = this.querySelector('script[type="application/json"]')
      if (fallbackScript) {
        try {
          const fallback = JSON.parse(fallbackScript.textContent.trim())
          data['1'] = { options: this.listOptions, variants: fallback }
        } catch (error) {
          console.error('bundle-variant-radios: unable to parse fallback variant data', error)
        }
      }
    }

    return data
  }

  getVariantDataFor(quantityIndex) {
    const key = String(quantityIndex)
    if (this.variantDataByQuantity && this.variantDataByQuantity[key]) {
      return this.variantDataByQuantity[key]
    }
    if (!this.variantDataFallback) {
      const fallbackScript = this.querySelector('script[type="application/json"]')
      if (fallbackScript) {
        try {
          const parsed = JSON.parse(fallbackScript.textContent.trim())
          this.variantDataFallback = { options: this.listOptions, variants: parsed }
        } catch (error) {
          this.variantDataFallback = { options: this.listOptions, variants: [] }
        }
      } else {
        this.variantDataFallback = { options: this.listOptions, variants: [] }
      }
    }
    return this.variantDataFallback
  }

  collectQuantityIndexes() {
    return Array.from(this.querySelectorAll('.bundle-variants-content__inner'))
      .map((instance) => instance.dataset.quantityIndex)
      .filter(Boolean)
  }

  getQuantityIndexes() {
    if (!this.quantityIndexOrder || !this.quantityIndexOrder.length) {
      this.quantityIndexOrder = this.collectQuantityIndexes()
    }
    return this.quantityIndexOrder
  }
}

customElements.define('bundle-variant-radios', BundleVariantRadios);
